import { render, staticRenderFns } from "./UiPills.vue?vue&type=template&id=0df0c50e&"
import script from "./UiPills.vue?vue&type=script&lang=js&"
export * from "./UiPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports